'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Constants


var _selectionConstants = require('../../../../common/elements/selectionConstants');

var SELECTION_ACTION_TYPES = _interopRequireWildcard(_selectionConstants);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

exports.default = function (state, action) {
    // Don't redo element selections. This feels better because otherwise the user's cursor will get 'stuck' in editors
    // and the user will have to deselect the element in order to continue undoing
    if (action.type === SELECTION_ACTION_TYPES.ELEMENTS_SELECTED) {
        return null;
    }

    return _extends({}, action, {
        isRedo: true,
        transactionId: action.transactionId
    });
};


//////////////////
// WEBPACK FOOTER
// ./src/client/utils/undoRedo/middleware/createRedoAction.js
// module id = 2144
// module chunks = 0